<template>
  <div
    class="card-footer d-flex justify-content-between"
    v-if="links.length > 1"
  >
    <ul
      class="list-pagination-prev pagination pagination-tabs card-pagination"
      v-if="hasPrevPage"
    >
      <li class="page-item cursor-pointer" @click="onGoPrev">
        <span class="page-link ps-0 pe-4 border-end">
          <i class="fa-solid fa-chevron-left me-1"></i> Anterior
        </span>
      </li>
    </ul>
    <div v-else></div>

    <ul class="list-pagination pagination pagination-tabs card-pagination">
      <li
        v-for="(link, index) in links"
        @click="onGoToPage(link.label)"
        :class="{ active: link.active }"
        :key="index"
        class="cursor-pointer"
      >
        <span class="page">{{ link.label }}</span>
      </li>
    </ul>

    <ul
      class="list-pagination-next pagination pagination-tabs card-pagination"
      v-if="hasNextPage"
    >
      <li class="page-item cursor-pointer" @click="onGoNext">
        <span class="page-link ps-4 pe-0 border-start">
          Próxima <i class="fa-solid fa-chevron-right ms-1"></i>
        </span>
      </li>
    </ul>
    <div v-else></div>
  </div>
</template>

<script setup lang="ts">
import { PaginationLinks } from "@/@types";

type TablePaginationProps = {
  links: PaginationLinks[];
  hasPrevPage: boolean;
  hasNextPage: boolean;
};

const emits = defineEmits(["onPrev", "onNext", "onPageLink"]);

const {
  links = [],
  hasNextPage,
  hasPrevPage,
} = defineProps<TablePaginationProps>();

const onGoPrev = () => emits("onPrev");
const onGoNext = () => emits("onNext");
const onGoToPage = (page: string) => emits("onPageLink", page);
</script>
